/**
 * Object containing default baselayers for the VEF.
 * @memberof vef.defaults
 */
const BASELAYERS = {
    "rtopo": {
        "thumbnail": "https://cdn.awi.de/images/map_thumbnails/rtopo.jpg",
        "EPSG:4326": {
            "type": "wms",
            "name": "0",
            "availableCrs": ["EPSG:4326", "EPSG:3857"],
            "serviceUrl": "https://maps.awi.de/services/basemaps/rtopo/r_wld_db/ims",
            "serviceVersion": "1.3.0",
            "serviceSoftware": "ESRI",
            "attribution": "<a href='https://leafletjs.com' target='_blank' title='A JS library for interactive maps'>Leaflet</a> | <a href='https://www.awi.de/en/' target='_blank'>Alfred Wegener Institute</a>"
        },
        "EPSG:3995": {
            "type": "wms",
            "name": "0",
            "availableCrs": ["EPSG:3995"],
            "serviceUrl": "https://maps.awi.de/services/basemaps/rtopo/r_arc_db/ims",
            "serviceVersion": "1.3.0",
            "serviceSoftware": "ESRI",
            "attribution": "<a href='https://leafletjs.com' target='_blank' title='A JS library for interactive maps'>Leaflet</a> | <a href='https://www.awi.de/en/' target='_blank'>Alfred Wegener Institute</a>"
        },
        "EPSG:3031": {
            "type": "wms",
            "name": "0",
            "availableCrs": ["EPSG:3031"],
            "serviceUrl": "https://maps.awi.de/services/basemaps/rtopo/r_ant_db/ims",
            "serviceVersion": "1.3.0",
            "serviceSoftware": "ESRI",
            "attribution": "<a href='https://leafletjs.com' target='_blank' title='A JS library for interactive maps'>Leaflet</a> | <a href='https://www.awi.de/en/' target='_blank'>Alfred Wegener Institute</a>"
        }
    },
    "blue": {
        "thumbnail": "https://cdn.awi.de/images/map_thumbnails/blue.png",
        "EPSG:4326": {
            "serviceTitle": "AWI Basemap Service",
            "serviceUrl": "https://maps.awi.de/services/basemaps/gs/awi/wms",
            "type": "wms",
            "serviceName": "WMS",
            "serviceAccessConstraints": "CC-BY 4.0",
            "serviceFees": "NONE",
            "serviceAbstract": "The AWI Basemap is a global background map rendered and shaded RGB version of the current GEBCO grid with ice overlays from ADD, GLIMS and GIMP. It is available in three projections, EPSG:4326 for the global map as well as EPSG:3995 and EPSG:3031 for the polar stereographic versions.",
            "serviceSoftware": "geoserver",
            "serviceVersion": "1.3.0",
            "filterType": "OGC",
            "serviceKeywords": [
                "basemap",
                "bathymetry",
                "awi",
                "gis"
            ],
            "availableCrs": [
                "EPSG:3857",
                "EPSG:4326",
                "EPSG:3995",
                "EPSG:3031",
                "EPSG:3411",
                "EPSG:3412",
                "CRS:84",
                "EPSG:4326",
                "CRS:84"
            ],
            "title": "AWI Basemap World View (blue)",
            "originalTitle": "AWI Basemap World View (blue)",
            "catalogId": "WMS::https://maps.awi.de/services/basemaps/gs/awi/wms::world_blue",
            "name": "world_blue",
            "availableStyles": {},
            "keywords": [
                "AWI Basemap",
                "Bathymetry"
            ],
            "minX": -180,
            "maxX": 180,
            "minY": -90,
            "maxY": 90
        },
        "EPSG:3995": {
            "serviceTitle": "AWI Basemap Service",
            "serviceUrl": "https://maps.awi.de/services/basemaps/gs/awi/wms",
            "type": "wms",
            "serviceName": "WMS",
            "serviceAccessConstraints": "CC-BY 4.0",
            "serviceFees": "NONE",
            "serviceAbstract": "The AWI Basemap is a global background map rendered and shaded RGB version of the current GEBCO grid with ice overlays from ADD, GLIMS and GIMP. It is available in three projections, EPSG:4326 for the global map as well as EPSG:3995 and EPSG:3031 for the polar stereographic versions.",
            "serviceSoftware": "geoserver",
            "serviceVersion": "1.3.0",
            "filterType": "OGC",
            "serviceKeywords": [
                "basemap",
                "bathymetry",
                "awi",
                "gis"
            ],
            "availableCrs": [
                "EPSG:3857",
                "EPSG:4326",
                "EPSG:3995",
                "EPSG:3031",
                "EPSG:3411",
                "EPSG:3412",
                "CRS:84",
                "EPSG:3995",
                "CRS:84"
            ],
            "title": "AWI Basemap Arctic View (blue)",
            "originalTitle": "AWI Basemap Arctic View (blue)",
            "catalogId": "WMS::https://maps.awi.de/services/basemaps/gs/awi/wms::arctic_blue",
            "name": "arctic_blue",
            "availableStyles": {},
            "keywords": [
                "Bathymetry",
                "AWI Basemap"
            ],
            "minX": -180,
            "maxX": 180,
            "minY": 11.419782236895058,
            "maxY": 90
        },
        "EPSG:3031": {
            "serviceTitle": "AWI Basemap Service",
            "serviceUrl": "https://maps.awi.de/services/basemaps/gs/awi/wms",
            "type": "wms",
            "serviceName": "WMS",
            "serviceAccessConstraints": "CC-BY 4.0",
            "serviceFees": "NONE",
            "serviceAbstract": "The AWI Basemap is a global background map rendered and shaded RGB version of the current GEBCO grid with ice overlays from ADD, GLIMS and GIMP. It is available in three projections, EPSG:4326 for the global map as well as EPSG:3995 and EPSG:3031 for the polar stereographic versions.",
            "serviceSoftware": "geoserver",
            "serviceVersion": "1.3.0",
            "filterType": "OGC",
            "serviceKeywords": [
                "basemap",
                "bathymetry",
                "awi",
                "gis"
            ],
            "availableCrs": [
                "EPSG:3857",
                "EPSG:4326",
                "EPSG:3995",
                "EPSG:3031",
                "EPSG:3411",
                "EPSG:3412",
                "CRS:84",
                "EPSG:3031",
                "CRS:84"
            ],
            "title": "AWI Basemap Antarctic View (blue)",
            "originalTitle": "AWI Basemap Antarctic View (blue)",
            "catalogId": "WMS::https://maps.awi.de/services/basemaps/gs/awi/wms::antarctic_blue",
            "name": "antarctic_blue",
            "availableStyles": {},
            "keywords": [
                "AWI Basemap",
                "Bathymetry"
            ],
            "minX": -180,
            "maxX": 180,
            "minY": -90,
            "maxY": -11.419782236895058
        }
    },
    "greyblue": {
        "thumbnail": "https://cdn.awi.de/images/map_thumbnails/greyblue.png",
        "EPSG:4326": {
            "serviceTitle": "AWI Basemap Service",
            "serviceUrl": "https://maps.awi.de/services/basemaps/gs/awi/wms",
            "type": "wms",
            "serviceName": "WMS",
            "serviceAccessConstraints": "CC-BY 4.0",
            "serviceFees": "NONE",
            "serviceAbstract": "The AWI Basemap is a global background map rendered and shaded RGB version of the current GEBCO grid with ice overlays from ADD, GLIMS and GIMP. It is available in three projections, EPSG:4326 for the global map as well as EPSG:3995 and EPSG:3031 for the polar stereographic versions.",
            "serviceSoftware": "geoserver",
            "serviceVersion": "1.3.0",
            "filterType": "OGC",
            "serviceKeywords": [
                "basemap",
                "bathymetry",
                "awi",
                "gis"
            ],
            "availableCrs": [
                "EPSG:3857",
                "EPSG:4326",
                "EPSG:3995",
                "EPSG:3031",
                "EPSG:3411",
                "EPSG:3412",
                "CRS:84",
                "EPSG:4326",
                "CRS:84"
            ],
            "title": "AWI Basemap World View (greyblue)",
            "originalTitle": "AWI Basemap World View (greyblue)",
            "catalogId": "WMS::https://maps.awi.de/services/basemaps/gs/awi/wms::world_greyblue",
            "name": "world_greyblue",
            "availableStyles": {},
            "keywords": [
                "AWI Basemap",
                "Bathymetry"
            ],
            "minX": -180,
            "maxX": 180,
            "minY": -90,
            "maxY": 90
        },
        "EPSG:3995": {
            "serviceTitle": "AWI Basemap Service",
            "serviceUrl": "https://maps.awi.de/services/basemaps/gs/awi/wms",
            "type": "wms",
            "serviceName": "WMS",
            "serviceAccessConstraints": "CC-BY 4.0",
            "serviceFees": "NONE",
            "serviceAbstract": "The AWI Basemap is a global background map rendered and shaded RGB version of the current GEBCO grid with ice overlays from ADD, GLIMS and GIMP. It is available in three projections, EPSG:4326 for the global map as well as EPSG:3995 and EPSG:3031 for the polar stereographic versions.",
            "serviceSoftware": "geoserver",
            "serviceVersion": "1.3.0",
            "filterType": "OGC",
            "serviceKeywords": [
                "basemap",
                "bathymetry",
                "awi",
                "gis"
            ],
            "availableCrs": [
                "EPSG:3857",
                "EPSG:4326",
                "EPSG:3995",
                "EPSG:3031",
                "EPSG:3411",
                "EPSG:3412",
                "CRS:84",
                "EPSG:3995",
                "CRS:84"
            ],
            "title": "AWI Basemap Arctic View (greyblue)",
            "originalTitle": "AWI Basemap Arctic View (greyblue)",
            "catalogId": "WMS::https://maps.awi.de/services/basemaps/gs/awi/wms::arctic_greyblue",
            "name": "arctic_greyblue",
            "availableStyles": {},
            "keywords": [
                "Bathymetry",
                "AWI Basemap"
            ],
            "minX": -180,
            "maxX": 180,
            "minY": 11.419782236895058,
            "maxY": 90
        },
        "EPSG:3031": {
            "serviceTitle": "AWI Basemap Service",
            "serviceUrl": "https://maps.awi.de/services/basemaps/gs/awi/wms",
            "type": "wms",
            "serviceName": "WMS",
            "serviceAccessConstraints": "CC-BY 4.0",
            "serviceFees": "NONE",
            "serviceAbstract": "The AWI Basemap is a global background map rendered and shaded RGB version of the current GEBCO grid with ice overlays from ADD, GLIMS and GIMP. It is available in three projections, EPSG:4326 for the global map as well as EPSG:3995 and EPSG:3031 for the polar stereographic versions.",
            "serviceSoftware": "geoserver",
            "serviceVersion": "1.3.0",
            "filterType": "OGC",
            "serviceKeywords": [
                "basemap",
                "bathymetry",
                "awi",
                "gis"
            ],
            "availableCrs": [
                "EPSG:3857",
                "EPSG:4326",
                "EPSG:3995",
                "EPSG:3031",
                "EPSG:3411",
                "EPSG:3412",
                "CRS:84",
                "EPSG:3031",
                "CRS:84"
            ],
            "title": "AWI Basemap Antarctic View (greyblue)",
            "originalTitle": "AWI Basemap Antarctic View (greyblue)",
            "catalogId": "WMS::https://maps.awi.de/services/basemaps/gs/awi/wms::antarctic_greyblue",
            "name": "antarctic_greyblue",
            "availableStyles": {},
            "keywords": [
                "Bathymetry",
                "AWI Basemap"
            ],
            "minX": -180,
            "maxX": 180,
            "minY": -90,
            "maxY": -11.419782236895058
        }
    },
    "grey": {
        "thumbnail": "https://cdn.awi.de/images/map_thumbnails/grey.png",
        "EPSG:4326": {
            "serviceTitle": "AWI Basemap Service",
            "serviceUrl": "https://maps.awi.de/services/basemaps/gs/awi/wms",
            "type": "wms",
            "serviceName": "WMS",
            "serviceAccessConstraints": "CC-BY 4.0",
            "serviceFees": "NONE",
            "serviceAbstract": "The AWI Basemap is a global background map rendered and shaded RGB version of the current GEBCO grid with ice overlays from ADD, GLIMS and GIMP. It is available in three projections, EPSG:4326 for the global map as well as EPSG:3995 and EPSG:3031 for the polar stereographic versions.",
            "serviceSoftware": "geoserver",
            "serviceVersion": "1.3.0",
            "filterType": "OGC",
            "serviceKeywords": [
                "basemap",
                "bathymetry",
                "awi",
                "gis"
            ],
            "availableCrs": [
                "EPSG:3857",
                "EPSG:4326",
                "EPSG:3995",
                "EPSG:3031",
                "EPSG:3411",
                "EPSG:3412",
                "CRS:84",
                "EPSG:4326",
                "CRS:84"
            ],
            "title": "AWI Basemap World View (grey)",
            "originalTitle": "AWI Basemap World View (grey)",
            "catalogId": "WMS::https://maps.awi.de/services/basemaps/gs/awi/wms::world_grey",
            "name": "world_grey",
            "availableStyles": {},
            "keywords": [
                "Bathymetry",
                "AWI Basemap"
            ],
            "minX": -180,
            "maxX": 180,
            "minY": -90,
            "maxY": 90
        },
        "EPSG:3995": {
            "serviceTitle": "AWI Basemap Service",
            "serviceUrl": "https://maps.awi.de/services/basemaps/gs/awi/wms",
            "type": "wms",
            "serviceName": "WMS",
            "serviceAccessConstraints": "CC-BY 4.0",
            "serviceFees": "NONE",
            "serviceAbstract": "The AWI Basemap is a global background map rendered and shaded RGB version of the current GEBCO grid with ice overlays from ADD, GLIMS and GIMP. It is available in three projections, EPSG:4326 for the global map as well as EPSG:3995 and EPSG:3031 for the polar stereographic versions.",
            "serviceSoftware": "geoserver",
            "serviceVersion": "1.3.0",
            "filterType": "OGC",
            "serviceKeywords": [
                "basemap",
                "bathymetry",
                "awi",
                "gis"
            ],
            "availableCrs": [
                "EPSG:3857",
                "EPSG:4326",
                "EPSG:3995",
                "EPSG:3031",
                "EPSG:3411",
                "EPSG:3412",
                "CRS:84",
                "EPSG:3995",
                "CRS:84"
            ],
            "title": "AWI Basemap Arctic View (grey)",
            "originalTitle": "AWI Basemap Arctic View (grey)",
            "catalogId": "WMS::https://maps.awi.de/services/basemaps/gs/awi/wms::arctic_grey",
            "name": "arctic_grey",
            "availableStyles": {},
            "keywords": [
                "AWI Basemap",
                "Bathymetry"
            ],
            "minX": -180,
            "maxX": 180,
            "minY": 11.419782236895058,
            "maxY": 90
        },
        "EPSG:3031": {
            "serviceTitle": "AWI Basemap Service",
            "serviceUrl": "https://maps.awi.de/services/basemaps/gs/awi/wms",
            "type": "wms",
            "serviceName": "WMS",
            "serviceAccessConstraints": "CC-BY 4.0",
            "serviceFees": "NONE",
            "serviceAbstract": "The AWI Basemap is a global background map rendered and shaded RGB version of the current GEBCO grid with ice overlays from ADD, GLIMS and GIMP. It is available in three projections, EPSG:4326 for the global map as well as EPSG:3995 and EPSG:3031 for the polar stereographic versions.",
            "serviceSoftware": "geoserver",
            "serviceVersion": "1.3.0",
            "filterType": "OGC",
            "serviceKeywords": [
                "basemap",
                "bathymetry",
                "awi",
                "gis"
            ],
            "availableCrs": [
                "EPSG:3857",
                "EPSG:4326",
                "EPSG:3995",
                "EPSG:3031",
                "EPSG:3411",
                "EPSG:3412",
                "CRS:84",
                "EPSG:3031",
                "CRS:84"
            ],
            "title": "AWI Basemap Antarctic View (grey)",
            "originalTitle": "AWI Basemap Antarctic View (grey)",
            "catalogId": "WMS::https://maps.awi.de/services/basemaps/gs/awi/wms::antarctic_grey",
            "name": "antarctic_grey",
            "availableStyles": {},
            "keywords": [
                "AWI Basemap",
                "Bathymetry"
            ],
            "minX": -180,
            "maxX": 180,
            "minY": -90,
            "maxY": -11.419782236895058
        }
    },
    "gebco": {
        "thumbnail": "https://cdn.awi.de/images/map_thumbnails/gebco.jpg",
        "EPSG:4326": {
            "type": "wms",
            "title": "GEBCO_LATEST_SUB_ICE_TOPO",
            "originalTitle": "GEBCO_LATEST_SUB_ICE_TOPO",
            "abstract": "This layer provides shaded relief imagery for a version of the GEBCO_2022 Grid that includes under-ice topography/bathymetry information for areas around Greenland and Antarctica.<br/><br/>GEBCO Bathymetric Compilation Group 2022 (2022). The GEBCO_2022 Grid - a continuous terrain model of the global oceans and land. NERC EDS British Oceanographic Data Centre NOC. doi:10.5285/e0f0bb80-ab44-2739-e053-6c86abc0289c",
            "availableCrs": [
                "EPSG:4326",
                "EPSG:3395",
                "EPSG:3857"
            ],
            "availableStyles": [
                "GEBCO_2022_legend"
            ],
            "name": "GEBCO_LATEST_SUB_ICE_TOPO",
            "serviceUrl": "https://www.gebco.net/data_and_products/gebco_web_services/web_map_service/mapserv",
            "serviceSoftware": "esri",
            "serviceVersion": "1.3.0",
            "serviceName": "WMS",
            "serviceTitle": "WMS for the GEBCO global bathymetric grid",
            "serviceAbstract": "The General Bathymetric Chart of the Oceans (GEBCO) consists of an international group of experts who work on the development of a range of bathymetric data sets and products. GEBCO operates under the joint auspices of the International Hydrographic Organization (IHO) and the Intergovernmental Oceanographic Commission (IOC) of UNESCO. See our web site for more information about GEBCO: https://www.gebco.net/.\n\nThis Web Map Service (WMS) provides access to data from GEBCO's latest bathymetric grid in the form of imagery for use in your applications. GEBCO's latest global grid is GEBCO_2022 and is a global elevation model at 15 arc-second intervals. Further information about the data sets included in the grid can be found in the documentation that accompanies the data set and is available from https://www.gebco.net/data_and_products/gridded_bathymetry_data/. The GEBCO Grid is produced through the framework of the Nippon Foundation-GEBCO Seabed 2030 Project https://seabed2030.org.\n\nThis service provides access to the latest GEBCO grid (GEBCO_2022) in the form of a flat image layer 'GEBCO_LATEST_2' and as a shaded relief image layer, 'GEBCO_LATEST'. Layer 'GEBCO_LATEST_3' shows those pixels that are based on measured data (largely ship-track data). Areas based on interpolation are set to transparent. The layer 'GEBCO_LATEST_SUB_ICE_TOPO' provides shaded relief imagery for a version of the GEBCO_2022 Grid that includes under-ice topography/bathymetry information for Greenland and Antarctica. \n\nThe GEBCO Grid is accompanied by a Source Data Type Identifier (TID) grid - this indicates the type of data that the corresponding cells in the GEBCO grid are based on.\n\nInformation on how to download the GEBCO's grids can be found at https://www.gebco.net/data_and_products/gridded_bathymetry_data/.\n\nPlease note that GEBCO's grids are mainly deeper water data sets and do not contain detailed bathymetry in shallower water areas. This WMS has been developed by the British Oceanographic Data Centre (BODC) on behalf of GEBCO.\n\nIf imagery from this WMS is included in web sites, reports and digital and printed imagery then we request that the source of the dataset is acknowledged and be of the form 'Imagery reproduced from the GEBCO_2022 Grid, www.gebco.net'.\n\nPlease note that it is intended that when a new version of the GEBCO grid is released then the 'LATEST' layers will be updated to use this new data set. This change should be transparent to the user of the WMS. Advanced notice will be given before this change takes place. Previous versions of the WMS layers are available from GEBCO's web site.",
            "serviceKeywords": [
                "Bathymetry",
                "Grid",
                "GEBCO",
                "seafloor",
                "imagery"
            ],
            "serviceCrs": []
        }
    },
    "coastline": {
        "thumbnail": "https://cdn.awi.de/images/map_thumbnails/coastlines.png",
        "EPSG:4326": {
            "type": "wms",
            "title": "GSHHG Shorelines",
            "name": "shorelines_4326",
            "abstract": "Based on GSHHG (https://www.soest.hawaii.edu/pwessel/gshhg/), showing L1, L5, L6 data.",
            "keywords": ["GSHHG", "Coastlines", "Shorelines"],
            "availableStyles": ["shorelines", "shorelines_by_zoom"],
            "availableCrs": ["EPSG:4326", "EPSG:3857"],
            "serviceUrl": "https://maps.awi.de/services/common/standard/wms",
            "serviceTitle": "Web Map Services at Alfred Wegener Institute",
            "serviceName": "WMS",
            "serviceVersion": "1.3.0",
            "serviceSoftware": "GeoServer",
            "serviceKeywords": ["WFS", "WMS"],
            "attribution": "<a href='https://leafletjs.com' target='_blank' title='A JS library for interactive maps'>Leaflet</a> | <a href='https://www.awi.de/en/' target='_blank'>Alfred Wegener Institute</a>"
        }
    },
    "osm": {
        "thumbnail": "https://cdn.awi.de/images/map_thumbnails/osm.png",
        "EPSG:4326": {
            "serviceTitle": "GFZ Web Map Services MapProxy",
            "serviceUrl": "https://map-services.gfz-potsdam.de/mapproxy/service",
            "type": "wms",
            "serviceName": "WMS",
            "serviceAccessConstraints": "By using this web service you agree to the Terms of Use as defined here: https://www.gfz-potsdam.de/en/terms-of-use/",
            "serviceSoftware": "geoserver",
            "serviceVersion": "1.3.0",
            "filterType": "OGC",
            "availableCrs": [
                "EPSG:900913",
                "EPSG:3857",
                "EPSG:4326"
            ],
            "title": "Open Streetmap Tiles",
            "originalTitle": "Open Streetmap Tiles",
            "catalogId": "WMS::https://map-services.gfz-potsdam.de/mapproxy/service::osm",
            "name": "osm",
            "minX": -180,
            "maxX": 180,
            "minY": -85,
            "maxY": 85,
            "attribution": "<a href='https://leafletjs.com' target='_blank' title='A JS library for interactive maps'>Leaflet</a> | <a href='https://gfz-potsdam.de' target='_blank'>GFZ-Potsdam</a>"
        }
    }
};

BASELAYERS.rtopo["EPSG:3857"] = Object.assign({}, BASELAYERS.rtopo["EPSG:4326"]);
BASELAYERS.blue["EPSG:3857"] = Object.assign({}, BASELAYERS.blue["EPSG:4326"]);
BASELAYERS.grey["EPSG:3857"] = Object.assign({}, BASELAYERS.grey["EPSG:4326"]);
BASELAYERS.greyblue["EPSG:3857"] = Object.assign({}, BASELAYERS.greyblue["EPSG:4326"]);
BASELAYERS.gebco["EPSG:3857"] = Object.assign({}, BASELAYERS.gebco["EPSG:4326"]);
BASELAYERS.coastline["EPSG:3857"] = Object.assign({}, BASELAYERS.coastline["EPSG:4326"]);
BASELAYERS.osm["EPSG:3857"] = Object.assign({}, BASELAYERS.osm["EPSG:4326"]);

export { BASELAYERS };
